import { Dispatch } from 'redux';
import { IUserAttr } from '../actions/session';
import * as Actions from '../actions/skill';
import AbstractScenario from './AbstractScenario';

export interface ISkillParam {
	userAttr: IUserAttr;
	userId: string;
	adminView: boolean;
}
export interface ICertificationParam {
	careerId: string;
	userId: string;
	reasonCode: string;
	seq: string;
}
export default class SkillScenarioFactory {
	/**
	 * 実施中スキル取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchOnGoingSkill(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ISkillParam> {
			protected process(skillParam: ISkillParam) {
				// データ取得
				const param = {
					accessType: '10',
					lang: skillParam.userAttr.lang,
					locale: skillParam.userAttr.locale,
					userId: skillParam.adminView
						? skillParam.userId
						: skillParam.userAttr.userId,
				};
				return this.read('per_skill_OngSKBlockCollection', param).then(
					data => {
						const skillData = data.onGoingSKGridList;
						this.dispatch(
							Actions.setOnGoingSkillData({ skillData })
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}
	/**
	 * 実施中スキルマップ取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchOnGoingSkillMap(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ISkillParam> {
			protected process(skillParam: ISkillParam) {
				// データ取得
				const param = {
					accessType: '10',
					lang: skillParam.userAttr.lang,
					locale: skillParam.userAttr.locale,
					userId: skillParam.adminView
						? skillParam.userId
						: skillParam.userAttr.userId,
				};
				return this.read('per_skill_OngSKMBlockCollection', param).then(
					data => {
						const skillMapData = data.onGoingSKMGridList;
						this.dispatch(
							Actions.setOnGoingSkillMapData({ skillMapData })
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 実績スキル取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchResultSkill(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ISkillParam> {
			protected process(skillParam: ISkillParam) {
				// データ取得
				const param = {
					accessType: '10',
					lang: skillParam.userAttr.lang,
					locale: skillParam.userAttr.locale,
					userId: skillParam.adminView
						? skillParam.userId
						: skillParam.userAttr.userId,
				};
				return this.read('per_skill_RsltSKBlockCollection', param).then(
					data => {
						const skillData = data.resultSKGridList;
						this.dispatch(
							Actions.setResultSkillData({
								skillData,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}
	/**
	 * 実績スキルマップ取得シナリオ作成
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchResultSkillMap(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ISkillParam> {
			protected process(skillParam: ISkillParam) {
				// データ取得
				const param = {
					accessType: '10',
					lang: skillParam.userAttr.lang,
					locale: skillParam.userAttr.locale,
					userId: skillParam.adminView
						? skillParam.userId
						: skillParam.userAttr.userId,
				};
				return this.read(
					'per_skill_RsltSKMBlockCollection',
					param
				).then(data => {
					const skillMapData = data.resultSKMGridList;
					this.dispatch(
						Actions.setResultSkillMapData({ skillMapData })
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * アセスメント情報の取得
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchAssessmentInfo(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerID: string) {
				// データ取得
				const param = {
					accessType: '10',
					careerid: careerID,
				};
				return this.read('per_skill_AssessmentBlockModel', param);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 認定証アップロード画面の初期化
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static createDoFetchCertificationInfo(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			ICertificationParam
		> {
			protected process(arg: ICertificationParam) {
				// データ取得
				const param = {
					accessType: '10',
					careerID: arg.careerId,
					reasonCode: arg.reasonCode,
					seq: parseInt(arg.seq, 10),
					userId: arg.userId,
				};
				return this.read('per_skill_CertificationBlockModel', param);
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/SkillScenarioFactory.ts